module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.insertNewActionActive || _vm.pasteActionActive) ? _c('div', {
    staticClass: "layout-divider-controls"
  }, [(_vm.insertNewActionActive) ? _c('b-button', {
    staticClass: "control create-button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleCreateClick
    }
  }, [_vm._v("\n\t    +\n\t")]) : _vm._e(), _vm._v(" "), (_vm.pasteActionActive) ? _c('b-button', {
    staticClass: "control paste-button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handlePasteClick
    }
  }, [_vm._v("\n\t\teinfügen\n\t")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4af3ee0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoLayout/DividerActionBar.vue
// module id = 669
// module chunks = 0